import { useEffect, useState } from "react"
import JainGraduation from "../../../assets/jain_graduation.jpeg";
import Event1 from '../../../assets/moments/event_1.jpg'
import Talk4 from '../../../assets/moments/talk_4.jpg'
import Talk6 from '../../../assets/moments/talk_6.jpeg'
import Kar2 from '../../../assets/moments/kar_2.jpg'
import Award1 from '../../../assets/moments/award_1.jpg'

const images = [
    JainGraduation,
    Event1,
    Talk4,
    Talk6,
    Kar2,
    Award1
]

const HeroImages = () => {
    const [index, setIndex] = useState(0)

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % images.length)
        }, 5000)

        return () => clearInterval(interval)
    }, [])

    return <div className="stack-container">
        {images.map((src, i) => (
            <img
                key={i}
                src={src}
                className={`stack-image ${i === index ? "visible" : ""}`}
                alt=""
            />
        ))}
    </div>
}

export default HeroImages